module.exports = __webpack_public_path__ + "static/media/advertorial3.1a5c38cf.png";